import { useState } from "react";
import api, { API, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Upload, X } from "lucide-react";

export default function CoverUploader({ value, onChange }) {
  const [uploading, setUploading] = useState(false);
  const upload = async (file) => {
    if (!file) return;
    if (!file.type.startsWith("image/")) { toast.error("Please choose an image file"); return; }
    if (file.size > 5 * 1024 * 1024) { toast.error("Image must be under 5 MB"); return; }
    const fd = new FormData();
    fd.append("file", file);
    setUploading(true);
    try {
      const { data } = await api.post("/upload/cover", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.path);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setUploading(false);
    }
  };

  const previewUrl = value ? `${API}/files/${value}` : null;

  return (
    <div>
      <label className="text-[10px] uppercase tracking-widest text-[#6E675E] font-mono-brass block mb-1.5">Cover art / scan (optional)</label>
      {previewUrl ? (
        <div className="relative w-40 h-52 rounded-sm overflow-hidden border border-[rgba(217,180,114,0.2)]">
          <img src={previewUrl} alt="cover" className="w-full h-full object-cover" data-testid="cover-preview" />
          <button
            type="button"
            onClick={() => onChange(null)}
            className="absolute top-1 right-1 w-6 h-6 flex items-center justify-center bg-black/70 text-[#F7F3EC] rounded-sm hover:bg-black/90"
            data-testid="cover-remove"
          >
            <X className="w-3.5 h-3.5" />
          </button>
        </div>
      ) : (
        <label className="flex flex-col items-center justify-center w-40 h-52 border border-dashed border-[rgba(217,180,114,0.3)] rounded-sm cursor-pointer hover:border-[#D9B472] hover:bg-[rgba(217,180,114,0.04)] transition-colors duration-200" data-testid="cover-uploader">
          <input
            type="file"
            accept="image/*"
            className="hidden"
            onChange={(e) => upload(e.target.files?.[0])}
            data-testid="cover-file-input"
          />
          <Upload className="w-5 h-5 text-[#D9B472] mb-2" />
          <span className="text-xs text-[#A8A095] font-mono-brass uppercase tracking-widest">{uploading ? "Uploading…" : "Add cover"}</span>
          <span className="text-[10px] text-[#6E675E] mt-1 font-serif-body">JPG · PNG · WEBP</span>
        </label>
      )}
    </div>
  );
}
